import styled from '@emotion/styled';

import { Link } from 'react-scroll';

import COLOR from '../../../../../shared/constant/colorset';

import { speed } from '../../../../../shared/styles';

const MenuWrapper = styled.div<{ isSelected: boolean; }>`
  display: flex;
  flex: 1;
  border-width: ${(props) => (
    props.isSelected ? '1px 0 0 1px' : '1px 0 1px 1px'
  )};
  border-color: ${COLOR.kurlyGray200};
  border-style: solid;
  background-color: ${(props) => (
    props.isSelected ? `${COLOR.kurlyWhite}` : `${COLOR.kurlyGray100}`
  )};

  :last-of-type {
    border-right-width: 1px;
  }
`;

const Menu = styled(Link)`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Text = styled.span<{ isSelected: boolean; }>`
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (
    props.isSelected ? `${COLOR.kurlyPurple}` : `${COLOR.kurlyGray600}`
  )};
`;

const Count = styled.span<{ isSelected: boolean; }>`
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ isSelected }) => isSelected ? COLOR.kurlyPurple : COLOR.kurlyGray450};
  line-height: 16px;
`;

interface Props {
  name: string;
  link: string;
  selected: string;
  onClickMenu(value: string): void;
  isCount?: boolean;
  count?: number;
}

export default function MenuItem({
  name,
  link,
  selected,
  onClickMenu,
  isCount = false,
  count = 0,
}: Props) {
  const isSelected = selected === link;

  return (
    <MenuWrapper
      isSelected={isSelected}
    >
      <Menu
        to={link}
        spy
        smooth
        offset={-160}
        duration={speed.scroll}
        onClick={() => onClickMenu(link)}
      >
        <Text
          isSelected={isSelected}
        >
          {name}
        </Text>
        {isCount && (
          <Count isSelected={isSelected}>
            ({count})
          </Count>
        )}
      </Menu>
    </MenuWrapper>
  );
}
